import script from "./SearchTextBox.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchTextBox.vue?vue&type=script&setup=true&lang=ts"

import "./SearchTextBox.vue?vue&type=style&index=0&id=5c848959&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c848959"]])

export default __exports__